import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaCode,
  FaEnvelope,
  FaPhone,
  FaPhoneAlt,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";
import { Mail, Phone } from "lucide-react";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <>
      <footer className="footer-section text-white pt-5 pb-3">
        <div className="container">
          <div className="row g-4 mb-5">
            {/* Brand Info */}
            <div className="col-lg-4 col-md-6">
              <img
                src={config?.logo}
                alt="Gifty Hampers"
                className="footer-logo mb-4"
              />
              <p
                className="footer-text small mb-4"
                style={{ lineHeight: "1.8" }}
              >
                Click Buy Gifts is a premier supplier of corporate gifts in
                Pune, renowned for its exceptional quality, diverse product
                range, and unparalleled customer service.
              </p>
             
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 col-6">
              <h6 className="fw-bold mb-4 text-uppercase tracking-wider">
                Quick Links
              </h6>
              <ul className="list-unstyled footer-links">
                <li>
                  <Link to="/shop">Shop</Link>
                </li>
                <li>
                   <Link to="/blog">Blogs</Link>
                </li>
                <li>
                   <Link to="/about-us">About Us</Link>
                </li>
                <li>
                <Link to="/contact-us">Contact US</Link>
                </li>
                
              </ul>
            </div>

            {/* Customer Support */}
            <div className="col-lg-2 col-md-6 col-6">
              <h6 className="fw-bold mb-4 text-uppercase tracking-wider">
                Support
              </h6>
              <ul className="list-unstyled footer-links">
                <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                   <Link to="/return-and-refund-policy">Return & Refund Policy</Link>
                </li>
               
               
              </ul>
            </div>

            {/* Newsletter */}
            <div className="col-lg-4 col-md-6">
              <h6 className="fw-bold mb-4 text-uppercase tracking-wider">
                Stay Updated
              </h6>

              <div className="mt-4">
                <div className="d-flex align-items-center gap-2 mb-2 footer-text small">
                  <FaPhoneAlt size={16} className="footer-text" />{" "}
                  <span>{config?.phone}</span>
                </div>
                <div className="d-flex align-items-center gap-2 footer-text small">
                  <FaEnvelope size={16} className="footer-text" />{" "}
                  <span>{config?.email}</span>
                </div>
                <div className="d-flex gap-3 mt-3">
                  {config?.socialMedia?.facebook && (
                    <li>
                      <a
                        href={config?.socialMedia?.facebook}
                        target="_blank"
                        className="social-icon-link"
                      >
                        <FaFacebook size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.instagram && (
                    <li>
                      <a
                        href={config?.socialMedia?.instagram}
                        target="_blank"
                        className="social-icon-link"
                      >
                        <FaInstagram size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.twitter && (
                    <li>
                      <a
                        href={config?.socialMedia?.twitter}
                        target="_blank"
                        className="social-icon-link"
                      >
                        <FaTwitter size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.youtube && (
                    <li>
                      <a
                        href={config?.socialMedia?.youtube}
                        target="_blank"
                        className="social-icon-link"
                      >
                        <FaYoutube size={16} />
                      </a>
                    </li>
                  )}
                  {config?.socialMedia?.linkedin && (
                    <li>
                      <a
                        href={config?.socialMedia?.linkedin}
                        target="_blank"
                        className="social-icon-link"
                      >
                        <FaLinkedin size={16} />
                      </a>
                    </li>
                  )}
                </div>
              </div>
            </div>
          </div>

          <hr className="border-secondary opacity-25" />

          {/* BOTTOM BAR */}
          <div className="d-flex justify-content-between pt-3">
            <p className="small text-secondary mb-0">
              All Rights Reserved © 2026 Click Buy Gifts. A part of RK Trading Corporation.
            </p>

            <a
              href="https://axesell.com"
              className="floating-designer-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="floating-content">
                <img
                  src="/images/axesell_logo.png"
                  className="floating-icon"
                  alt="Axesell"
                />
              </div>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
